var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.14397C0 2.68932 0.180612 2.25328 0.502103 1.93179C0.823594 1.6103 1.25963 1.42969 1.71429 1.42969H14.2857C14.7404 1.42969 15.1764 1.6103 15.4979 1.93179C15.8194 2.25328 16 2.68932 16 3.14397V3.53483L8.43771 8.57712C8.30571 8.65656 8.15405 8.69734 8 8.69483C7.84595 8.69734 7.69429 8.65656 7.56229 8.57712L0 3.53483V3.14397ZM0 5.2514V12.8583C0 13.3129 0.180612 13.749 0.502103 14.0704C0.823594 14.3919 1.25963 14.5725 1.71429 14.5725H14.2857C14.7404 14.5725 15.1764 14.3919 15.4979 14.0704C15.8194 13.749 16 13.3129 16 12.8583V5.2514L9.22629 9.76797L9.22057 9.77254C8.85592 10.0044 8.43213 10.1263 8 10.1234C7.57143 10.1234 7.13943 10.0068 6.77943 9.77254L6.77371 9.76797L0 5.2514Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.08c3f6dcff73474850708082801623c3.svg";
export { ForwardRef as ReactComponent };